<template>
	<div class="carlist">
        <el-card>
            <span>车辆使用公司：  </span>
            <el-select v-model="car_search.gongsi" placeholder="车辆使用公司" style="width:180px;">
                <el-option
                    v-for="(item,i) in options2"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>

            <span >状态： </span>
            <el-select v-model="car_search.xz_status" placeholder="请选择" clearable>
                <el-option label="在用" value='在用'></el-option>
                <el-option label="闲置" value='闲置'></el-option>
                <el-option label="报废" value='报废'></el-option>
            </el-select>

            <span >车牌： </span>
            <el-input style="width:100px" v-model="car_search.chepai" placeholder="车牌号" clearable ></el-input>
            <el-button type="primary" icon="el-icon-search" @click="getList()" style="margin-left:20px">搜索</el-button>
            <el-button type="success" @click="add()" size="mini" style="margin-bottom:20px" icon="el-icon-circle-plus-outline">添加车辆</el-button>
            <el-button type="warning" @click="exportToExcel()" size="mini" style="margin-bottom:20px" icon="el-icon-circle-plus-outline">导出</el-button>

            <el-dialog
                title="车辆维护"
                :visible.sync="dialogVisible"
                width="400px">
                <el-row>
                    <el-col :span="6"><span>车牌</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.chepai" placeholder="车牌"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>运载量（吨）</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.yzl" placeholder="运载量（吨）"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>能源类型</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.nengyuan" placeholder="能源类型" style="width: 100%;" >
                            <el-option label="油车" value="油车"></el-option>
                            <el-option label="电车" value="电车"></el-option>
                            <el-option label="混动" value="混动"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>车辆类型</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.type" placeholder="车辆类型" style="width: 100%;" >
                            <el-option label="小车" value="小车"></el-option>
                            <el-option label="配送冷藏车" value="配送冷藏车"></el-option>
                            <el-option label="配送通风车" value="配送通风车"></el-option>
                            <el-option label="生猪采购车" value="生猪采购车"></el-option>
                            <el-option label="商务车" value="商务车"></el-option>
                            <el-option label="货车" value="货车"></el-option>
                            <el-option label="客车" value="客车"></el-option>
                            <el-option label="面包车" value="面包车"></el-option>
                            <el-option label="公务车" value="公务车"></el-option>
                            <el-option label="污泥车" value="污泥车"></el-option>
                            <el-option label="污水车" value="污水车"></el-option>
                            <el-option label="饲料车" value="饲料车"></el-option>
                            <el-option label="场外运猪车" value="场外运猪车"></el-option>
                            <el-option label="场外物资转运车" value="场外物资转运车"></el-option>
                            <el-option label="叉车" value="叉车"></el-option>
                            <el-option label="铲车" value="铲车"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>车辆来源</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.source" placeholder="车辆来源" style="width: 100%;" >
                            <el-option label="自有" value="自有"></el-option>
                            <el-option label="外租" value="外租"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>所属公司</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.shu_org" placeholder="车辆使用公司" style="width: 100%;" >
                            <el-option
                                v-for="(item,i) in options2"
                                :key="i"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>使用公司</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.yong_org" placeholder="车辆使用公司" style="width: 100%;" >
                            <el-option
                                v-for="(item,i) in options2"
                                :key="i"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>限定载重（吨）</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.zaizhong" placeholder="限定载重（吨）"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>标准满载头数</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.toushu" placeholder="标准满载头数"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>标准油耗</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.youhao" placeholder="标准油耗"></el-input>
                    </el-col>
                </el-row>
                
                <el-row>
                    <el-col :span="6"><span>状态</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.xz_status" placeholder="状态" style="width: 100%;">
                            <el-option label="在用" value="在用"></el-option>
                            <el-option label="闲置" value="闲置"></el-option>
                            <el-option label="报废" value="报废"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>承包</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.chengbao" placeholder="是否承包" style="width: 100%;">
                            <el-option label="是" value="是"></el-option>
                            <el-option label="否" value="否"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>部门</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="car.bumen" placeholder="部门" style="width: 100%;">
                            <el-option label="鲜品事业部" value="鲜品事业部"></el-option>
                            <el-option label="养殖事业部" value="养殖事业部"></el-option>
                            <el-option label="肉品事业部" value="肉品事业部"></el-option>
                            <el-option label="职能部" value="职能部"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>备注</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.mess" placeholder="备注"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>年审费</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.nianshen" placeholder="年审费"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>保险费</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.baoxian" placeholder="保险费(年)"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>折旧费</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.zhejiu" placeholder="折旧费(年)"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>维修费</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="car.weixiu" placeholder="维修费(年)"></el-input>
                    </el-col>
                </el-row>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                    <el-button type="primary" @click="submit()" size="mini">确 定</el-button>
                </span>
            </el-dialog>

            <el-table
                size="mini"
                :data="tableData"
                stripe
                height="70vh"
                id='outTable'
                border>
                <el-table-column
                    prop="create_time"
                    label="创建时间">
                </el-table-column>

                <el-table-column
                    prop="chepai"
                    label="车牌">
                </el-table-column>

                <el-table-column
                    prop="nengyuan"
                    label="能源">
                </el-table-column>

                <el-table-column
                    prop="yzl"
                    label="运载量（吨）">
                </el-table-column>

                <el-table-column
                    prop="type"
                    label="车辆类型">
                </el-table-column>

                <el-table-column
                    prop="source"
                    label="车辆来源">
                </el-table-column>

                <el-table-column
                    prop="shu_org"
                    label="所属公司">
                </el-table-column>

                <el-table-column
                    prop="yong_org"
                    label="使用公司">
                </el-table-column>

                <el-table-column
                    prop="zaizhong"
                    label="限定载重（吨）">
                </el-table-column>

                <el-table-column
                    prop="toushu"
                    label="标准满载头数">
                </el-table-column>

                <el-table-column
                    prop="youhao"
                    label="标准油耗">
                </el-table-column>

                <el-table-column
                    prop="xz_status"
                    label="状态">
                </el-table-column>

                <el-table-column
                    prop="chengbao"
                    label="承包">
                </el-table-column>

                <el-table-column
                    prop="bumen"
                    label="部门">
                </el-table-column>

                <el-table-column
                    prop="mess"
                    label="备注">
                </el-table-column>

                <el-table-column
                    prop="nianshen"
                    label="年审">
                </el-table-column>

                <el-table-column
                    prop="baoxian"
                    label="保险">
                </el-table-column>

                <el-table-column
                    prop="zhejiu"
                    label="折旧">
                </el-table-column>

                <el-table-column
                    prop="weixiu"
                    label="维修">
                </el-table-column>
                
                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>

                <el-table-column label="操作" width="200" fixed="right">
                    <template slot-scope="scope" >
                        <el-button type="primary" size="mini" @click="edit(scope.row)" icon="el-icon-edit">修改</el-button>
                        <el-button type="danger" size="mini" @click="del(scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

        </el-card>

    </div>
</template>

<script>
    import option from "../config/option.js"
    import { carList,carAdd,carEdit,carDel,powerList} from '../router/api';
    import * as XLSX from 'xlsx';
    import FileSaver from "file-saver";

	export default{
		data(){
			return {
                car: {
                    id:'',
                    chepai:'',
                    yzl:'',
                    type:'',
                    shu_org:'',
                    yong_org:'',
                    youhao:'',
                    xz_status:'',
                    bumen:'',
                    nengyuan:'',
                    chengbao:'',
                    nianshen:'',
                    baoxian:'',
                    zhejiu:'',
                    weixiu:'',
                    source:'',
                    zaizhong:'',
                    toushu:''
                },
                car_search: {
                    gongsi:'',
                    xz_status:'在用',
                    chepai:'',
                },
                dialogVisible:false,
                tableData:[],
                options2:[],
            }
        },
      
        async mounted() {
            await this.getUser()
            await this.getList()
        },
		methods: {
            exportToExcel() {
                // 1. 定义表头
                const headers = [
                    '创建时间', '车牌', '能源', '运载量（吨）', '车辆类型', 
                    '车辆来源', '所属公司', '使用公司', '限定载重（吨）',
                    '标准满载头数', '标准油耗', '状态', '承包', '部门',
                    '备注', '年审', '保险', '折旧', '维修', '操作人'
                ];
                
                // 2. 从 tableData 提取数据
                const data = this.tableData.map(item => [
                    item.create_time,
                    item.chepai,
                    item.nengyuan,
                    item.yzl,
                    item.type,
                    item.source,
                    item.shu_org,
                    item.yong_org,
                    item.zaizhong,
                    item.toushu,
                    item.youhao,
                    item.xz_status,
                    item.chengbao,
                    item.bumen,
                    item.mess,
                    item.nianshen,
                    item.baoxian,
                    item.zhejiu,
                    item.weixiu,
                    item.operate
                ]);
                
                // 3. 创建工作簿
                const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, '车辆数据');
                
                // 4. 导出文件
                const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
                try {
                    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '车辆数据.xlsx');
                } catch(e) {
                    console.error('导出失败:', e);
                }
                return wbout;
            },
            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list2  = res.data[0].car.split(',')
                    list2.map(item=> {
                        this.options2.push(item)
                    })
                    this.car_search.gongsi = this.options2[0]
                    if(this.car_search.gongsi == '全部') {
                        this.options2 = option.org
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            async getList() {
                carList({
                    id:'',
                    chepai:this.car_search.chepai,
                    xz_status:this.car_search.xz_status,
                    gongsi:this.car_search.gongsi == '全部'? '' : this.car_search.gongsi
                }).then(res=> {
                    if(res.code==1) {
                        this.tableData = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            submit() {
                if(
                    this.car.chepai==''||this.car.nengyuan==''||this.car.yzl==''||this.car.type==''||
                    this.car.shu_org==''||this.car.yong_org==''||this.car.youhao==''||this.car.bumen==''||this.xz_status==''||
                    this.car.nianshen==''||this.car.baoxian==''||this.car.zhejiu==''||this.car.weixiu==''
                ){
                    this.$message.error('请填写完整信息');
                    return;
                } 
                if(this.car.id) {
                    carEdit({
                        chepai: this.car.chepai,
                        yzl: this.car.yzl,
                        nengyuan: this.car.nengyuan,
                        type: this.car.type,
                        shu_org: this.car.shu_org,
                        yong_org: this.car.yong_org,
                        youhao: this.car.youhao,
                        car_id: this.car.id,
                        bumen:this.car.bumen,
                        xz_status: this.car.xz_status,
                        chengbao:this.car.chengbao,
                        mess:this.car.mess,
                        operate:localStorage.getItem('ws_name'),
                        nianshen:this.car.nianshen,
                        baoxian:this.car.baoxian,
                        zhejiu:this.car.zhejiu,
                        weixiu:this.car.weixiu,
                        source:this.car.source,
                        zaizhong:this.car.zaizhong,
                        toushu:this.car.toushu
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                } else {
                    carAdd({
                        chepai: this.car.chepai,
                        yzl: this.car.yzl,
                        nengyuan: this.car.nengyuan,
                        type: this.car.type,
                        shu_org: this.car.shu_org,
                        yong_org: this.car.yong_org,
                        youhao: this.car.youhao,
                        xz_status: this.car.xz_status,
                        bumen: this.car.bumen,
                        mess:this.car.mess,
                        chengbao:this.car.chengbao,
                        operate:localStorage.getItem('ws_name'),
                        nianshen:this.car.nianshen,
                        baoxian:this.car.baoxian,
                        zhejiu:this.car.zhejiu,
                        weixiu:this.car.weixiu,
                        source:this.car.source,
                        zaizhong:this.car.zaizhong,
                        toushu:this.car.toushu
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },

            edit(row) {
                this.dialogVisible = true
                this.car =  {
                    id: row.id,
                    chepai:row.chepai,
                    yzl:row.yzl,
                    nengyuan:row.nengyuan,
                    type:row.type,
                    shu_org:row.shu_org,
                    yong_org:row.yong_org,
                    youhao:row.youhao,
                    xz_status:row.xz_status,
                    chengbao:row.chengbao,
                    mess:row.mess,
                    bumen:row.bumen,
                    nianshen:row.nianshen,
                    baoxian:row.baoxian,
                    zhejiu:row.zhejiu,
                    weixiu:row.weixiu,
                    source:row.source,
                    zaizhong:row.zaizhong,
                    toushu:row.toushu
                }
            },

            add() {
                this.dialogVisible = true
                this.car =  {
                    id:'',
                    chepai:'',
                    yzl:'空',
                    nengyuan:'油车',
                    type:'',
                    shu_org:'',
                    yong_org:this.car_search.gongsi,
                    youhao:'',
                    xz_status:'在用',
                    chengbao:'否',
                    mess:'',
                    bumen:this.car.bumen,
                    nianshen:'',
                    baoxian:'',
                    zhejiu:'',
                    weixiu:'',
                    source:'',
                    zaizhong:'',
                    toushu:''
                }
            },
            
            del(row) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    carDel({
                        id:row.id,
                    }).then(res=> {
                        this.$message.success(res.msg);
                        this.getList()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message.error('取消操作');
                });
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .carlist  {
        .el-row {
            box-sizing: border-box;
            height: 28px;
            line-height: 28px;
            margin-bottom:10px;
        }
        /deep/ .el-dialog__body {
            padding: 10px 20px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
        }
        span {
            font-size: 12px;
        }
        .el-input {
            margin-right: 20px;
        }

        .el-select {
            width:140px;
            margin-right: 20px;
        }
        .cladmin main {
            margin-bottom: 20px;
        }
    }
</style>
